/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {

  // Remove empty P tags created by WP inside of Accordion and Orbit
  jQuery('.accordion p:empty, .orbit p:empty').remove();

  // Adds Flex Video to YouTube and Vimeo Embeds
  jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
    if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
      jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
    } else {
      jQuery(this).wrap("<div class='responsive-embed'/>");
    }
  });

  /********
   * Initialise Gallery Slider for Gallery snippet
   ********/
  jQuery('.gallery--zoomed').slick({
    slidesToShow: 1,
    infinite: false,
    dots: false,
    lazyLoad: 'ondemand',
  });

  /********
   * Inject reveal newsletter to link
   *
   * Allows alternate method to open foundation reveail
   * between data-reveal="id" and href="dp-goto://id"
   ********/
  jQuery('a[href^="dp-goto://"]').click(function(e){
    e.preventDefault();
    var id = jQuery(this).attr('href').substring(10);
    jQuery('#'+id).foundation('open');
  });

  /** Event Slider Initialisation **/
  // initialize slider for events
  jQuery('.event-slider .slider-wrapper').slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    swipe: false,
    arrows: true,
    prevArrow: "<img src='/content/themes/DailyPress/assets/images/Prev-Arrow.png' class='a-left control-c slick-prev' />",
    nextArrow: "<img src='/content/themes/DailyPress/assets/images/Next-Arrow.png' class='a-left control-c slick-next' />",
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 680,
        settings: {
            slidesToShow: 1,
        }
      }
    ]
  });

}); //END document ready


/******
 * Mobile and Desktop Menu Switch
 *
 * Desktop Menu: Second level menu dropdown
 * Mobile Menu: Second level menu slide to open
 ******/
var menuState = "";
var mobileDesktopMenuSwitch = debounce(function() {
  if(menuState !== "mobile" && window.innerWidth < 1024) {
    menuState = "mobile";
    jQuery('.hamburger-icon').on('click', function(e){
      e.preventDefault();
      jQuery(this).toggleClass('active');
      jQuery(this).parents('.mobile-menu').toggleClass('first-level-open');
      jQuery('.mobile-menu').removeClass('second-level-open');
      jQuery('.menu-item-has-children').removeClass('open');
      jQuery('html').toggleClass('no-scroll');
    });

    jQuery('.menu-item-has-children > a').click(function(e){
      e.preventDefault();
      jQuery(this).parents('.mobile-menu').toggleClass('second-level-open');
      jQuery(this).parent().toggleClass('open');
    });

    jQuery('.menu-item-has-children > a').one('click', function(e){
      //This code onle need to run once
      jQuery(this).siblings('.second-level-menu').find('.second-level-parent').append(jQuery(this).clone());
    });

    jQuery('.mobile-menu .back-to-main').click(function(e) {
      jQuery('.mobile-menu').removeClass('second-level-open');
      jQuery('.menu-item-has-children').removeClass('open');
    });
  } else if(window.innerWidth >= 1024) {
    menuState = "desktop";
    jQuery('.hamburger-icon').off('click');
    jQuery('.menu-item-has-children > a').off('click');
    jQuery('.menu-item-has-children > a').off('click');
    jQuery('.second-level-menu .back').off('click');
  }
}, 250);

mobileDesktopMenuSwitch(); //run one on load
window.addEventListener('resize', mobileDesktopMenuSwitch);


/********
 * Initialise Hero Slider
 *
 * Add listener for play animation/video on the next slide
 ********/

//initiate effect (animation or video play)
function initHeroEffect(slick, control) {
  var currentSlide = slick.find(".slick-current .hero-slide");

  if(currentSlide.hasClass('hero-customised') ||
     currentSlide.hasClass('hero-image')) {
    switch (control) {
      case "play":
        currentSlide.trigger('playAnimation');
        break;
      case "reset":
        currentSlide.trigger('resetAnimation');
        break;
    }
  } else if(currentSlide.hasClass('hero-video')) {
    var player = currentSlide.find("iframe").get(0);
    switch (control) {
      case "play":
        player.contentWindow.postMessage(JSON.stringify({
          "event": "command",
          "func": "mute"
        }), "*");
        player.contentWindow.postMessage(JSON.stringify({
          "event": "command",
          "func": "playVideo"
        }), "*");
        break;
      case "reset": //pause video on reset
        player.contentWindow.postMessage(JSON.stringify({
          "event": "command",
          "func": "pauseVideo"
        }), "*");
        break;
    }
  }
}
var heroSlider = jQuery('.hero');
heroSlider.on("init", function(slick){
  slick = jQuery(slick.currentTarget);
  setTimeout(function() {  //slick take a while to create elements after init
    //reset all animations except the first one
    slick.find('.slick-slide:not(:first-child) .hero-slide').trigger('resetAnimation');

    //play if first slide is video
    var firstSlide = slick.find("[data-slick-index='0'] .hero-slide");
    if(firstSlide.hasClass('hero-video')) {
      initHeroEffect(slick, "play");
    }
  }, 1000);
});
heroSlider.on("beforeChange", function(event, slick) {
  slick = jQuery(slick.$slider);
  initHeroEffect(slick, "reset");
});
heroSlider.on("afterChange", function(event, slick) {
  slick = jQuery(slick.$slider);
  initHeroEffect(slick, "play");
});

if(jQuery('.hero .hero-image').length > 1) {
  heroSlider.slick({
    slideToShow: 1,
    infinite: true,
    dots: false,
    swipeToSlide: false,
    arrows: true,
    autoplay: false,
    autoplaySpeed: 7000,
    prevArrow: "<img src='/content/uploads/2018/07/Previous-Arrow.png' class='a-left control-c slick-prev' />",
    nextArrow: "<img src='/content/uploads/2018/07/Next-Arrow.png' class='a-left control-c slick-next' />",
  });
}


/********
 * Check if element is visibile
 *
 * Used for running animations only when the element is appeared on the screen
 ********/

function isElementInViewport (el) {
  if (typeof jQuery === "function" && el instanceof jQuery) {
    el = el[0];
  }

  var rect = el.getBoundingClientRect();

  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /*or $(window).height() */
    rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
  );
}

function onVisibilityChange(el, callback) {
  var old_visible;
  return function () {
    var visible = isElementInViewport(el);
    if (visible != old_visible) {
      old_visible = visible;
      if (typeof callback == 'function') {
        callback();
      }
    }
  }
}


/********
 * Add an image popup for every <img> wrapped in <a>
 *
 * Image popup is generated from the href attribute on a tag
 ********/
var popupImages = jQuery('.popup_image a > img');
popupImages.each(function(){
  var src = jQuery(this).parent().attr('href');
  jQuery(this).parent().append('<div class="popup_image__popup"><img src="'+src+'" /></div>');
});
jQuery('.popup_image a > img').parent().click(function(e) {
  e.preventDefault();
  jQuery(this).find('.popup_image__popup').addClass('popup_image__popup--active');
});
jQuery('.popup_image__popup').click(function(e){
  e.stopPropagation();
  e.preventDefault();
  jQuery(this).removeClass('popup_image__popup--active');
});
